import { usePopover } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, CircularProgress, Typography } from '@mui/material';
import { memo, MouseEvent } from 'react';
import { useRelevancyConfig } from '../../hooks/use-relevancy-config';
import { RelevancySummaryPopup } from '../relevancy-summary-popup';
import * as Styled from './styles';
import * as SX from './sx';
import type { CircularProgressRelevancyProps as Props } from './types';

export const CircularProgressRelevancy = memo(
  ({ className, relevancy }: Props) => {
    const state = usePopover();

    const handleClick = (e: MouseEvent<HTMLElement>) => {
      state.onOpen(e.currentTarget);
    };

    const relevancyData = useRelevancyConfig(relevancy);

    return (
      <Styled.Wrapper
        className={classnames('CircularProgressRelevancy', className)}
        sx={SX.root}
      >
        <Box sx={SX.circular} onClick={handleClick}>
          <CircularProgress
            variant="determinate"
            value={relevancy?.score || 10}
            color={relevancyData?.color}
            thickness={4}
          />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="body4" component="div" color="textSecondary">
              <Typography variant="body4" fontWeight={700}>
                {Math.round(relevancy?.score || 0)}
              </Typography>
            </Typography>
          </Box>
        </Box>

        <RelevancySummaryPopup state={state} relevancy={relevancy} />
      </Styled.Wrapper>
    );
  }
);

CircularProgressRelevancy.displayName = 'CircularProgressRelevancy';
